import { css } from 'lit';
import { TemplateResult, html } from 'lit';

/**
 * Add <sup> tags around timezone string
 *
 * @param {string}dateString formatted date ending with a timezone part
 * {string} @returns html
 */

export function formatTimezoneSup(dateString: string): TemplateResult {
	const parts = dateString.split(' ');
	const timezone = parts[parts.length - 1];
	const dateWithoutTimezone = parts.slice(0, -1).join(' ');

	return html`${dateWithoutTimezone} <sup>${timezone}</sup>`;
}
export default formatTimezoneSup;
